import { render, staticRenderFns } from "./WhitelabelLocations.vue?vue&type=template&id=3be0ddee&scoped=true&"
import script from "./WhitelabelLocations.vue?vue&type=script&lang=js&"
export * from "./WhitelabelLocations.vue?vue&type=script&lang=js&"
import style0 from "./WhitelabelLocations.vue?vue&type=style&index=0&id=3be0ddee&lang=less&scoped=true&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0ddee",
  null
  
)

export default component.exports